import React, { useState } from "react";
import { allAnswered, answerFor, composeAnswer, sendsOnTap, togglePick } from "../../../lib/artemis/ask";

// Artemis's clarifying questions (WEB-7134): tap a choice or type one, then Send. Shown in place of the
// suggested follow-ups on the latest reply only; once answered, the next question shows what was picked.

const AskCard = ({ questions, onAsk }) => {
  const [picks, setPicks] = useState({})
  const [other, setOther] = useState({})
  const onTap = sendsOnTap(questions)
  const ready = allAnswered(questions, picks, other)
  const send = () => { if (ready) onAsk(composeAnswer(questions, picks, other)) }

  const pick = (question, label) => {
    if (onTap) {
      onAsk(label)
      return
    }
    setPicks(p => togglePick(p, question, label))
    // A tap means the choice, not what was typed for this question.
    setOther(o => ({ ...o, [question.id]: '' }))
  }

  return (
    <section className="artemis-ask" aria-label="Artemis needs a bit more to go on">
      {questions.map(q => (
        <fieldset key={q.id} className="artemis-ask-question">
          {questions.length > 1 && <legend className="artemis-ask-legend">{q.question}</legend>}
          {questions.length === 1 && <legend className="artemis-visually-hidden">{q.question}</legend>}
          {q.options.length > 0 && (
            <div className="artemis-ask-options">
              {q.options.map(label => {
                const on = !answerFor(q, {}, other) && (picks[q.id] || []).includes(label)
                return (
                  <button key={label} type="button" aria-pressed={on}
                    className={`artemis-follow-up artemis-ask-option ${on ? 'artemis-ask-option-on' : ''}`}
                    onClick={() => pick(q, label)}>
                    {label}
                  </button>
                )
              })}
            </div>
          )}
          {q.allowOther && !onTap && (
            <input type="text" className="artemis-ask-other"
              aria-label={q.options.length > 0 ? `Something else for: ${q.question}` : q.question}
              placeholder={q.options.length > 0 ? 'Something else…' : 'Your answer…'}
              value={other[q.id] || ''}
              onChange={e => setOther({ ...other, [q.id]: e.target.value })}
              onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); send() } }} />
          )}
        </fieldset>
      ))}
      {!onTap && (
        <div className="artemis-ask-actions">
          <button type="button" className="artemis-small-button artemis-ask-send" disabled={!ready} onClick={send}>Send</button>
        </div>
      )}
    </section>
  )
}

export default AskCard
